import React from "react";
import { ArrowRight, BrainCircuit } from "lucide-react";
import CompanionProfilePageV2 from "@/components/daily/CompanionProfilePageV2";
import { AppCard } from "@/components/daily/CompanionAppUi";
import {
  assessmentUpgradeCopy,
  needsRobustAssessmentUpgrade,
} from "@/components/assessment/assessmentVersion";

const CompanionProfilePageV3 = ({ assessment, onRetake, ...props }) => {
  const upgradeAvailable = needsRobustAssessmentUpgrade(assessment);
  return (
    <div data-testid="companion-profile-v3">
      {upgradeAvailable && (
        <AppCard tone="action" className="mb-4" data-testid="robust-assessment-upgrade-card">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
            <div className="flex items-start gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white">
                <BrainCircuit size={21} className="forr-text-teal-deep" />
              </div>
              <div>
                <div className="forr-overline">{assessmentUpgradeCopy.eyebrow}</div>
                <h2 className="mt-2 font-display text-2xl forr-text-ink">
                  {assessmentUpgradeCopy.title}
                </h2>
                <p className="mt-3 max-w-3xl text-sm leading-relaxed forr-text-soft">
                  {assessmentUpgradeCopy.body}
                </p>
                <p className="mt-2 text-xs leading-relaxed forr-text-mute">
                  Your current assessment, check-ins, calendar, nutrition and body-mass context, response history, and Companion data remain intact. The current baseline is replaced only after the new assessment is completed.
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={onRetake}
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-medium forr-btn-primary"
            >
              Take new assessment <ArrowRight size={16} />
            </button>
          </div>
        </AppCard>
      )}
      <CompanionProfilePageV2 assessment={assessment} {...props} />
    </div>
  );
};

export default CompanionProfilePageV3;
